module.exports = __webpack_public_path__ + "img/bonfirered.a41bd6e1.svg";